import React from 'react'

export default function CuisineFresh({freshData}) {
  return (
    <>
      <section className="cuisine-fresh-area">
        <div className="container">
          <div className="row">

            {freshData.map((item, index) => (
              <div className="col-lg-3 col-md-6" key={index}>
                <div className="cuisine-fresh-box">
                  <img src={item.img} alt={item.title} className="img-responsive" />
                  <span>{item.title}</span>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>
    </>
  )
}
